  <template>
  <div>
    <a-card v-if="CustomizationList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item label="模板名称">
                <a-input v-model="queryParam.modelName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业名称">
                <a-input v-model="queryParam.enterpriseName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="安装类别">
                <a-select v-decorator="['installType']" @change="installChange" :allowClear="true">
                  <a-select-option v-for="type in installTypes" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单类型">
                <a-select v-decorator="['orderType']" :allowClear="true">
                  <a-select-option v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{
                    type.typeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="品牌" style="margin-left: 28px">
                <!--<a-input   v-model="queryParam.brandId" />-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange6"
                  v-decorator="['brandId']"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data1" :title="item.brandName" :key="item.brandId">{{
                    item.brandName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="型号" style="margin-left: 28px">
                <!--<a-input  v-model="queryParam.modelId" />-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-decorator="['modelId']"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data2" :title="item.modelName" :key="item.modelId">{{
                    item.modelName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12" style="text-align: right">
              <a-button type="primary" htmlType="submit" @click="queryList(1)">查询</a-button>
              <a-button style="margin-left: 8px" @click="handleClear">清空</a-button>
            </a-col>
          </a-row>
          <a-divider />
          <a-row>
            <a-col style="text-align: right">
              <a-button type="primary" @click="imgSet" class="mr-10">萤石照片管理</a-button>
              <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
            </a-col>
          </a-row>
        </a-form>
        <!--<video :src="urlvideo+'&token='+token" controls></video>-->
        <a-table
          style="margin-top: 20px"
          size="default"
          ref="table"
          showHeader="false"
          :data-source="data"
          :columns="columns"
          :pagination="false"
          bordered
        >
          <!--<span slot="installType" slot-scope="text, record">-->
          <!--<td v-for="type in restaurantTypes" :key="type.code" v-if="record.installType == type.code">{{type.label}}</td>-->
          <!--</span>-->
          <span slot="action" slot-scope="text, record">
            <a v-if="detailEnabel" @click="handleShow(record)">查看</a>
            <a-divider v-if="detailEnabel" type="vertical" />
            <span v-if="addEnable">
              <a @click="handleEdit(record)" v-if="record.modelType == 1">配置</a>
              <a-divider type="vertical" v-if="record.modelType == 1" />
              <a @click="Edition(record)">编辑</a>
              <a-divider type="vertical" v-if="record.modelType == 1" />
              <a
                v-if="record.modelType == 1 && record.disableStatus == 1"
                @click="showStateOpen(record.enterpriseModelId)"
                >启用</a
              >
              <a
                v-if="record.modelType == 1 && record.disableStatus == 0"
                @click="showStateClose(record.enterpriseModelId)"
                >禁用</a
              >
              <a-divider type="vertical" v-if="record.modelType == 1 && editEnabel" />
            </span>
            <a v-if="record.modelType == 1 && editEnabel" @click="delByIds(record.enterpriseModelId)">删除</a>
          </span>
        </a-table>
        <a-pagination
          showQuickJumper
          showSizeChanger
          :pageSizeOptions="pageSizeOptions"
          :pageSize.sync="pageSize"
          @showSizeChange="onShowSizeChange"
          :total="total"
          v-model="current"
          @change="getdataList4"
          :showTotal="(total) => `总共 ${total} 条`"
          style="margin-top: 20px; text-align: end"
        />
      </div>
      <enterpriseCustomization-modal ref="modal" @ok="handleOk" />
      <!--todo 萤石照片管理-->
      <a-modal
        title="锁安-萤石照片类型管理"
        style="top: 50px"
        v-model="imgVisible"
        :width="1000"
        :confirmLoading="confirmLoading"
        @ok="handleSubmitImg"
        footer=""
        :destroyOnClose="true"
        class="solo"
      >
        <a-row :gutter="6">
          <a-col :span="12">
            <a-card title="锁安照片组">
              <a-radio-group name="radioGroup" v-model="imgType" @change="onChangeType">
                <a-radio v-for="(item, i) in orderTypeArr" :key="i" :value="item.orderTypeId">
                  {{ item.typeName }}
                </a-radio>
              </a-radio-group>
              <div class="mt-20 border" style="height: 500px; overflow-y: auto">
                <div
                  @click="changeTabKey(items)"
                  class="ptb-10 pointer"
                  :class="saleInfo.saleInfoName == items.saleInfoName ? 'bold blue' : ''"
                  v-for="(items, index) in saleList"
                  :key="index"
                >
                  {{ items.saleInfoName }}
                </div>
              </div>
            </a-card>
          </a-col>
          <a-col :span="12">
            <a-card title="萤石照片类型">
              <div class="flex_r">
                <a-button type="primary" @click="addImg">添加</a-button>
              </div>
              <div class="mt-10 border" style="height: 467px; overflow-y: auto">
                <a-form :form="form" @submit="handleSubmit">
                  <a-form-item
                    v-for="(k, i) in imgList"
                    :key="i"
                    label=""
                    :required="false"
                    style="margin-bottom: 10px"
                    class="flex solo"
                  >
                    <a-input placeholder="请输入萤石照片类型" style="width: 85%" v-model="k.ezvizSaleName" />
                    <span class="blue pointer" @click="remove(i)" style="margin-left: 5%">删除</span>
                  </a-form-item>
                </a-form>
              </div>
              <div class="flex">
                <div class="blue">提示：添加、修改或删除后点击保存才可生效</div>
                <a-button type="primary" @click="handleSubmitImg">保存</a-button>
              </div>
            </a-card>
          </a-col>
        </a-row>
      </a-modal>
      <!--配置-->
      <a-modal
        title="配置"
        style="top: 20px"
        v-model="visible"
        :width="1400"
        :confirmLoading="confirmLoading"
        @ok="handleSubmit"
        :destroyOnClose="true"
      >
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="企业名称" :label-col="formItemLayout1.labelCol" :wrapper-col="formItemLayout1.wrapperCol">
            <a-input-search style="margin-bottom: 8px" @search="onSearch" />
          </a-form-item>
          <div style="display: flex; flex-direction: row">
            <div style="width: 60%; display: inline-block">
              <span style="margin-left: 10%"><span style="color: red">*</span> 企业配置 : </span>

              <a-tree
                checkable
                v-model="checkedKeys"
                :expanded-keys="expandedKeys"
                :auto-expand-parent="autoExpandParent"
                :defaultExpandedKeys="['enterprise']"
                @expand="onExpand"
                :treeData="treeData"
                :defaultCheckedKeys="checkedKeys"
                style="margin-left: 20%"
                @check="onCheck"
              >
                <template slot="title" slot-scope="{ title }">
                  <span v-if="title.indexOf(searchValue) > -1">
                    {{ title.substr(0, title.indexOf(searchValue)) }}
                    <span style="color: #f50">{{ searchValue }}</span>
                    {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
                  </span>
                  <span v-else>{{ title }}</span>
                </template>
              </a-tree>
            </div>
            <div style="width: 40%; display: inline-block; position: relative">
              <span style="position: absolute; top: 0; left: -50px"><span style="color: red">*</span> 型号 : </span>
              <a-checkbox-group style="margin-top: 20px" @change="chooseList" v-model="modelIds">
                <a-row style="margin: 7px 0" v-for="item in treeData2" :key="item.modelId">
                  <a-col :span="24">
                    <a-checkbox :value="item.modelId">
                      {{ item.modelName }}
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
              <!--<a-checkbox-group style="margin-top: 20px" :options="treeData2"  @change="chooseList" >-->
              <!--</a-checkbox-group>-->
            </div>
          </div>
        </a-form>
      </a-modal>
    </a-card>
    <no-authority v-if="!CustomizationList"></no-authority>
  </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getList } from '@/api/order/orderList'
import {
  getModelNumber,
  getSelectBrand,
  entModelListSearch,
  deleteEntModel,
  enableEntModel,
  disableEntModel,
  getModelByEnterprise,
  getEntModelRelationDeatil,
  configEntModelRelation,
  getOrderType,
  getModelName,
  getSaleName,
  addSaleName,
} from '@/api/enterprise/enterpriseCustomization'
import EnterpriseCustomizationModal from './modules/EnterpriseCustomizationModal'
import NoAuthority from './NoAuthority'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import { getSelectTree, selectModelEnterprise } from '@/api/enterprise/model'

export default {
  name: 'EnterpriseCustomization',
  components: {
    EnterpriseCustomizationModal,
    NoAuthority,
  },
  data() {
    return {
      // // 加载数据方法 必须为 Promise 对象
      // loadData: parameter => {
      //   return entModelListSearch(Object.assign(parameter, this.queryParam))
      // },
      token: Vue.ls.get(ACCESS_TOKEN),
      form: this.$form.createForm(this),
      data: [],
      // 表头
      columns: [
        {
          title: '序号',
          width: 60,
          dataIndex: 'id',
          align: 'center',
        },
        {
          title: '操作',
          width: '60px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '模板名称',
          dataIndex: 'modelName',
          align: 'center',
        },
        {
          title: '修改时间',
          dataIndex: 'updateTime',
          align: 'center',
        },
        {
          title: '修改人',
          dataIndex: 'updateBy',
          align: 'center',
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '添加人',
          dataIndex: 'createBy',
          align: 'center',
        },
      ],
      addEnable: checkPermission('enterprise:enterpriseCustomizationadd:add'),
      editEnabel: checkPermission('enterprise:enterpriseCustomizationadd:edit'),
      detailEnabel: checkPermission('enterprise:enterpriseCustomization:detail'),
      CustomizationList: checkPermission('enterprise:enterpriseCustomization:list'),
      // 查询参数
      queryParam: {},
      List: [],
      // 字典为是否
      restaurantTypes: [],
      // 字典为安装类型
      installTypes: [],
      visible: false,

      formItemLayout1: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 2 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
      },
      // 分页
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      total: 0,
      current: 1,
      pageSize: 10,
      //树状图********************************
      expandedKeys: ['enterprise'], //受控展开的树节点
      checkedKeys: [], //复选
      selectedKeys: [],
      treeData: '',
      searchValue: '',
      autoExpandParent: true,
      modelId: '',
      numArr: [],
      dataList: [],
      treeData2: [],
      entModelId: '',
      modelIds: [],
      confirmLoading: false,
      backupsExpandedKeys: [],
      // url:require('file://D:/lockan/uploadPath/order/2020/07/03/123.jpg')
      urlvideo:
        'http://localhost:8000/api/dfs/download?fileName=/order/2020/07/03/e2e19c1f67e58e004dd6c070901d1498.mp4',
      data1: [],
      data2: [],

      // todo 萤石照片
      imgVisible: false,
      orderTypeArr: [],
      imgType: 1,
      saleList: [],
      saleInfo: {}, //锁安照片
      imgList: [],
    }
  },
  async created() {
    // 字典为安装类型
    this.installTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.installTypes.push({ code: key, label: value })
      // console.log(this.installTypes)
    })
    this.queryParam.pageNum = 1
    this.queryParam.pageSize = this.pageSize
    entModelListSearch(this.queryParam).then((res) => {
      console.log(res.rows)
      this.data = res.rows
      this.total = res.total
    })
  },
  methods: {
    // todo 萤石照片管理
    imgSet() {
      this.imgVisible = true
      getOrderType().then((res) => {
        this.orderTypeArr = res.rows.splice(0, 2)
        this.imgType = this.orderTypeArr[0].orderTypeId
        getModelName({
          orderType: this.imgType,
        }).then((res) => {
          this.saleList = res.data.saleList
          this.saleInfo = this.saleList[0]
          getSaleName({
            installType: 'SMART_SWITCH',
            orderType: this.imgType,
            suoanSaleName: this.saleInfo.saleInfoName,
          }).then((res) => {
            this.imgList = res.data || []
          })
        })
      })
    },
    onChangeType() {
      getModelName({
        orderType: this.imgType,
      }).then((res) => {
        this.saleList = res.data.saleList
        this.saleInfo = this.saleList[0]
        getSaleName({
          installType: 'SMART_SWITCH',
          orderType: this.imgType,
          suoanSaleName: this.saleInfo.saleInfoName,
        }).then((res) => {
          this.imgList = res.data || []
        })
      })
    },
    changeTabKey(items) {
      if (items.saleInfoName == this.saleInfo.saleInfoName) {
        return
      }
      this.saleInfo = items
      getSaleName({
        installType: 'SMART_SWITCH',
        orderType: this.imgType,
        suoanSaleName: this.saleInfo.saleInfoName,
      }).then((res) => {
        this.imgList = res.data || []
      })
    },
    addImg() {
      this.imgList.unshift({
        ezvizSaleName: '',
      })
    },
    remove(i) {
      this.imgList.splice(i, 1)
    },

    handleSubmitImg(e) {
      console.log(6666, this.imgType)
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(this.imgList)
          addSaleName({
            ...this.saleInfo,
            ezvizSouanSaleNameList: [
              {
                suoanSaleName: this.saleInfo.saleInfoName,
                ezvizSaleNameList: this.imgList.filter((el) => el.ezvizSaleName).map((item) => item.ezvizSaleName),
              },
            ],
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('保存成功')
            }
          })
        }
      })
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.queryList(current)
    },
    getdataList4(value = 1) {
      this.queryList(value)
    },
    onSearch(e) {
      console.log(e)
      this.searchValue = e
      var vm = this
      //添加这行代码是为了只点击搜索才触发
      vm.searchValue = vm.searchStr
      //如果搜索值为空，则不展开任何项，expandedKeys置为空
      //如果搜索值不位空，则expandedKeys的值要为搜索值的父亲及其所有祖先
      if (vm.searchValue === '') {
        vm.expandedKeys = []
      } else {
        //首先将展开项与展开项副本置为空
        vm.expandedKeys = []
        vm.backupsExpandedKeys = []
        //获取所有存在searchValue的节点
        let candidateKeysList = vm.getkeyList(e, vm.treeData, [])
        console.log(candidateKeysList)
        vm.checkedKeys = candidateKeysList
        //遍历满足条件的所有节点
        candidateKeysList.map((item) => {
          //获取每个节点的母亲节点
          var key = vm.getParentKey(item, vm.treeData)
          //当item是最高一级，父key为undefined，将不放入到数组中
          //如果母亲已存在于数组中，也不放入到数组中
          if (key && !vm.backupsExpandedKeys.some((item) => item === key)) vm.backupsExpandedKeys.push(key)
        })
        console.log(vm.backupsExpandedKeys)
        let length = this.backupsExpandedKeys.length
        for (let i = 0; i < length; i++) {
          vm.getAllParentKey(vm.backupsExpandedKeys[i], vm.treeData)
        }
        vm.expandedKeys = vm.backupsExpandedKeys.slice()
        console.log(vm.expandedKeys)
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    //获取节点中含有value的所有key集合
    getkeyList(value, tree, keyList) {
      console.log(value, tree, keyList)
      //遍历所有同一级的树
      for (let i = 0; i < tree.length; i++) {
        let node = tree[i]
        //如果该节点存在value值则push
        if (node.title.indexOf(value) > -1) {
          keyList.push(node.key)
        }
        //如果拥有孩子继续遍历
        if (node.children) {
          this.getkeyList(value, node.children, keyList)
        }
      }
      //因为是引用类型，所有每次递归操作的都是同一个数组
      return keyList
    },
    //该递归主要用于获取key的父亲节点的key值
    getParentKey(key, tree) {
      let parentKey, temp
      //遍历同级节点
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i]
        if (node.children) {
          //如果该节点的孩子中存在该key值，则该节点就是我们要找的父亲节点
          //如果不存在，继续遍历其子节点
          if (node.children.some((item) => item.key === key)) {
            parentKey = node.key
          } else if ((temp = this.getParentKey(key, node.children))) {
            //parentKey = this.getParentKey(key,node.children)
            //改进，避免二次遍历
            parentKey = temp
          }
        }
      }
      return parentKey
    },
    //获取该节点的所有祖先节点
    getAllParentKey(key, tree) {
      var parentKey
      if (key) {
        //获得父亲节点
        parentKey = this.getParentKey(key, tree)
        if (parentKey) {
          //如果父亲节点存在，判断是否已经存在于展开列表里，不存在就进行push
          if (!this.backupsExpandedKeys.some((item) => item === parentKey)) {
            this.backupsExpandedKeys.push(parentKey)
          }
          //继续向上查找祖先节点
          this.getAllParentKey(parentKey, tree)
        }
      }
    },

    Edition(record) {
      this.$refs.modal.edit(record)
    },
    handleShow(record) {
      this.$refs.modal.edit(record, 1)
    },
    handleOk() {
      this.queryList(this.current)
    },
    chooseList(e) {
      console.log(e)
      this.modelIds = e
    },
    handleSubmit() {
      var allData = {}
      allData.entModelId = this.entModelId
      allData.enterpriseIds = this.checkedKeys
      allData.modelIds = this.modelIds
      if (this.modelIds.length == 0) {
        this.$message.error('至少选择一个型号')
      } else {
        this.confirmLoading = true
        configEntModelRelation({ ...allData }).then((res) => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('配置成功')
            this.confirmLoading = false
            this.visible = false
            this.queryList(this.current)
          }
        })
      }
    },
    queryList(value) {
      this.queryParam.pageNum = value
      this.queryParam.pageSize = this.pageSize
      this.current = value
      this.queryParam.installType = this.form.getFieldValue('installType')
      this.queryParam.orderType = this.form.getFieldValue('orderType')
      this.queryParam.brandId = this.form.getFieldValue('brandId')
      this.queryParam.modelId = this.form.getFieldValue('modelId')
      entModelListSearch(this.queryParam).then((res) => {
        // console.log(res.rows)
        this.data = res.rows
        this.total = res.total
      })
    },
    handleClear() {
      this.queryParam = {}
      this.List = []
      this.data1 = []
      this.data2 = []
      this.form.setFieldsValue({ installType: undefined, orderType: undefined, brandId: undefined, modelId: undefined })
    },

    //配置
    handleEdit(record) {
      console.log(record.enterpriseModelId)
      this.entModelId = record.enterpriseModelId
      this.visible = true
      getSelectTree().then((res) => {
        console.log(res.data)
        this.treeData = res.data
      })
      getEntModelRelationDeatil({ entModelId: record.enterpriseModelId }).then((res) => {
        console.log(res)
        this.checkedKeys = res.data.enterpriseIds
        this.modelIds = res.data.modelIds
        console.log(this.modelIds)
        console.log(this.modelIds.toString())
        getModelByEnterprise(this.checkedKeys).then((res) => {
          console.log(res.data)
          this.treeData2 = res.data
        })
      })
    },
    //删除
    delByIds(entModelId) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          deleteEntModel({ entModelId }).then((res) => {
            if (res.code == 0) {
              that.$message.success('删除成功')
              that.queryList(that.current)
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    //启用
    showStateOpen(modelId) {
      enableEntModel({ modelId }).then((res) => {
        if (res.code == 0) {
          this.$message.success('启用成功')
          this.queryList(this.current)
        }
      })
    },
    //禁用
    showStateClose(modelId) {
      disableEntModel({ modelId }).then((res) => {
        if (res.code == 0) {
          this.$message.success('禁用成功')
          this.queryList(this.current)
        }
      })
    },
    // 树状图*********************************
    // 展开/收起节点时触发
    onExpand(expandedKeys) {
      // console.log('onExpand', expandedKeys);
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck(checkedKeys) {
      console.log('onCheck', checkedKeys)
      this.checkedKeys = checkedKeys
      getModelByEnterprise(this.checkedKeys).then((res) => {
        console.log(res.data)
        this.treeData2 = res.data
      })
    },
    // onChange(e) {
    //   const value = e.target.value;
    //   console.log(dataList)
    //   const expandedKeys = dataList
    //     .map(item => {
    //       if (item.title.indexOf(value) > -1) {
    //         return getParentKey(item.key, gData);
    //       }
    //       return null;
    //     })
    //     .filter((item, i, self) => item && self.indexOf(item) === i);
    //   Object.assign(this, {
    //     expandedKeys,
    //     searchValue: value,
    //     autoExpandParent: true,
    //   });
    //   console.log(value)
    // },
    handleAdd() {
      this.$refs.modal.add()
    },
    async installChange(e) {
      this.form.setFieldsValue({ orderType: undefined, brandId: undefined, modelId: undefined })
      this.List = []
      this.data1 = []
      this.data2 = []
      await getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
      if (e != undefined) {
        getSelectBrand({ installType: e }).then((res) => {
          // console.log(res.data)
          this.data1 = res.data
        })
      }
    },
    handleChange6(value) {
      // console.log(`selected ${value}`)
      this.form.setFieldsValue({
        modelId: undefined,
      })
      this.data2 = []
      if (value != undefined) {
        getModelNumber({ brandId: value }).then((res) => {
          // console.log(res.data)
          this.data2 = res.data
        })
      }
    },
  },
}
</script>

<style scoped>
.twobtn {
  width: 110px;
  font-size: 15px;
}
.video-js .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: block;
}
.ant-divider.ant-divider-horizontal {
  margin: 12px 0 !important;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
/deep/ .solo .ant-form-item-control-wrapper {
  width: 100% !important;
}
</style>
 
